import React, { useState, useEffect } from "react";
import {
	Col,
	Row,
	Button,
	CardText,
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Card,
	CardBody,
	Label,
} from "reactstrap";
import shallow from "zustand/shallow";
import NumberFormat from "react-number-format";

import ChildrenModal from "../components/modals/ChildrenModal";
import AchPaymentMethod from "./AchPaymentMethod";
import CreditCardPaymentMethod from "./CreditCardPaymentMethod";
import AccountPaymentForm from "./AccountPaymentForm";
import useCurrentAccountStore from "./AccountStore";
import ReactTable from "../components/tables/ReactTable";
import FilterColumn from "../utils/filterColumn";
import {
	CurrencyDisplayElement,
	DateDisplayElement,
} from "../features/deal/components/DisplayElement";
import {
	activateAutoPay,
	deactivateAutoPay,
	listPaymentMethods,
} from "../api/AutopayApi";
import SetupAutoPay from "./SetupAutoPay";
import Switch from "react-bootstrap-switch";
import ScheduledPayments from "./ScheduledPayments";
import { retrieveFailAlert } from "../utils/alertUtils";
import { showApiError } from "../utils/errorRoutingUtils";
import Swal from "sweetalert2";
import { useUserBhphPrivileges } from "../features/settings/subFeatures/settingsTabs/userManagement/useUserPrivileges";

const AccountAutoPay = () => {
	// — ACH modal state
	const [isACHOpen, setIsACHOpen] = useState(false);
	const toggleACH = () => setIsACHOpen((open) => !open);

	// — Credit Card modal state
	const [isCCOpen, setIsCCOpen] = useState(false);
	const toggleCC = () => setIsCCOpen((open) => !open);

	// — Add Payment Method dropdown state
	const [isOpen, setIsOpen] = useState(false);
	const toggleMethod = () => setIsOpen((o) => !o);
	// — Scheduled Payment modal state
	const [isScheduledOpen, setIsScheduledOpen] = useState(false);
	const toggleScheduled = () => setIsScheduledOpen((open) => !open);

	const handleCreditCard = () => {
		setIsOpen(false);
		setIsCCOpen(true);
	};
	const handleACH = () => {
		setIsOpen(false);
		setIsACHOpen(true);
	};

	// — load account & scheduledPayments from store
	const {
		account,
		scheduledPayments,
		autoPays,
		paymentMethods,
		digitzsPayments,
		editAutoPays,
		editAutoPayStatusAtIndex,
	} = useCurrentAccountStore(
		(state) => ({
			scheduledPayments: state.scheduledPayments,
			account: state.account,
			autoPays: state.autoPays,
			paymentMethods: state.paymentMethods,
			digitzsPayments: state.digitzsPayments,
			editAutoPays: state.editAutoPays,
			editAutoPayStatusAtIndex: state.editAutoPayStatusAtIndex,
		}),
		shallow
	);

	// — state for “Make a new Payment” modal
	const [currentIndex, setCurrentIndex] = useState();
	const [showAdd, setShowAdd] = useState(false);
	const toggleAdd = () => {
		if (!showAdd && autoPays.filter((obj) => obj.active === true).length > 0) {
			Swal.fire("Please deactivate all the Auto Pays before adding new one");
			return;
		}
		setShowAdd((open) => !open);
	};
	const [autoPayID, setAutoPayID] = useState();
	const privileges = useUserBhphPrivileges();
	const p = privileges();
	const hasPermission = p.setupAutopay;

	// — fetch payment methods
	// const [paymentMethods, setPaymentMethods] = useState([]);
	//const [autoPay, setAutopay] = useState([]);
	// useEffect(() => {
	// 	if (account?.id) {
	// 		console.log(account.id);
	// 		listPaymentMethods(account.id)
	// 			.then((res) => {
	// 				console.log(res.data.content);
	// 				if (res.data.content.length === 0) {
	// 					console.log("No payment methods found", paymentMethods);

	// 					return;
	// 				}
	// 				setPaymentMethods(res.data.content);
	// 				console.log(res.data.content);
	// 			})
	// 			.catch((err) => console.error("Failed to load payment methods", err));
	// 	}
	// 	// eslint-disable-next-line
	// }, []);

	// — columns for payment methods
	const pmColumns = [
		{
			Header: "#",
			accessor: (_r, idx) => idx + 1,
			style: { width: 20 },
		},
		{
			Header: "Method on file",
			accessor: (row) =>
				// return value === "ACH" ? "ACH" : "Credit Card";
				row.tokenType === "ACH" || row.tokenType === "bank"
					? `${
							row.bank.accountType
					  } ending in ••••${row.bank.accountNumber.slice(-4)}`
					: `${row.card.type} ending in ••••${row.card.cardNumber}`,
		},
		{
			Header: "Name",
			accessor: "name",
		},
		{
			Header: "Updated Date",
			accessor: "card.updatedDate",
			Cell: ({ value }) => <DateDisplayElement val={value} />,
		},
		{
			Header: "Status",
			accessor: "active",
			Cell: ({ value }) => {
				// console.log(value);
				// <Switch
				// 	value={value}
				// 	// onChange={() => handleEmployeeIsHidden(obj)}
				// />;
				return value ? "Active" : "Inactive";
			},
		},
		// {
		// 	Header: "Details",
		// 	accessor: (row) =>
		// 		row.type === "ACH"
		// 			? `${row.bank.accountName} ••••${row.bank.accountNumber.slice(-4)}`
		// 			: `${row.card.cardHolder} ••••${row.card.cardNumber.slice(-4)}`,
		// },
		// {
		// 	Header: "Actions",
		// 	accessor: (row) => row,
		// 	Cell: ({ value }) => (
		// 		<Button
		// 			size="sm"
		// 			onClick={() => {
		// 				// if (value.type === "ACH") {
		// 				// 	// open ACH modal in 'edit' mode
		// 				// 	setIsACHOpen(true);
		// 				// } else {
		// 				// 	// open CC modal in 'edit' mode
		// 				// 	setIsCCOpen(true);
		// 				// }
		// 			}}
		// 		>
		// 			Edit
		// 		</Button>
		// 	),
		// },
	];
	const handleChangeStatus = (row) => {
		const value = row.original;
		console.log(value);

		if (value.active) {
			deactivateAutoPay(value.id).then(
				(res) => {
					console.log(res);
					editAutoPayStatusAtIndex(row.index, false);
				},
				(err) => {
					console.log(err);
					if (!err.isGeneralError) {
						showApiError(err, retrieveFailAlert);
					}
				}
			);
		} else {
			activateAutoPay(value.id).then(
				(res) => {
					console.log(res);
					editAutoPayStatusAtIndex(row.index, true);
				},
				(err) => {
					console.log(err);
					if (!err.isGeneralError) {
						showApiError(err, retrieveFailAlert);
					}
				}
			);
		}
	};
	const handleScheduledPayment = (value) => {
		console.log(value);
		setAutoPayID(value.id);
		setIsScheduledOpen(true);
	};

	const autoPayColumns = [
		{
			Header: "Amount",
			accessor: "amount",
			Cell: ({ value }) => <CurrencyDisplayElement val={value} />,
		},
		{
			Header: "First Delivery Date",
			accessor: "firstDeliveryDate",
			Cell: ({ value }) => <DateDisplayElement val={value} />,
		},
		{
			Header: "Last Execution Date",
			accessor: "lastExecutionDate",
			Cell: ({ value }) => <DateDisplayElement val={value} />,
		},

		{
			Header: "Number of Payments",
			accessor: "numOfPayments",
		},
		{
			Header: "Number of Executed",
			accessor: "totalExecutedTimes",
		},
		{
			Header: "Status",
			accessor: (row) => row,
			Cell: ({ row }) => {
				const isActive = row.original.active;
				return (
					<Switch
						value={isActive}
						disabled={!hasPermission}
						onChange={() => handleChangeStatus(row)}
					/>
				);
			},
		},
		{
			Header: "Period",
			accessor: "frequency",
			Cell: ({ value }) => {
				const labels = ["Weekly", "Bi-Weekly", "Semi-Monthly", "Monthly"];
				return labels[value] ?? "Unknown";
			},
		},

		{
			Header: "Description",
			accessor: "label",
		},
		{
			Header: "Actions",
			accessor: (row) => row,
			Cell: ({ value }) => (
				<Button size="sm" onClick={() => handleScheduledPayment(value)}>
					View
				</Button>
			),
		},
	];
	const pmtHistory = [
		{
			Header: "Type",
			accessor: "pmtType",
		},
		{
			Header: "Method",
			accessor: "method",
		},
		{
			Header: "Amount",
			accessor: "amount",
			Cell: ({ value }) => <CurrencyDisplayElement val={value} />,
		},
		{
			Header: "Delivery Date",
			accessor: "dmsTimestamp",
			Cell: ({ value }) => <DateDisplayElement val={value} />,
		},

		{
			Header: "DMS Receipt Number",
			accessor: "dmsReceiptNum",
		},
		{
			Header: "Status",
			accessor: "message",
		},
	];

	return (
		<>
			{/** ACH Setup Modal **/}
			<ChildrenModal
				size="lg"
				modal={isACHOpen}
				toggle={toggleACH}
				// modalTitle="Setup ACH"
			>
				<AchPaymentMethod
					dmsCustomerId={account.buyerRecNum}
					accountID={account.id}
					toggle={toggleACH}
				/>
			</ChildrenModal>

			{/** Credit Card Setup Modal **/}
			<ChildrenModal
				size="lg"
				modal={isCCOpen}
				toggle={toggleCC}
				// modalTitle="Setup Credit Card"
			>
				<CreditCardPaymentMethod
					dmsCustomerId={account.buyerRecNum}
					accountID={account.id}
					toggle={toggleCC}
				/>
			</ChildrenModal>
			<ChildrenModal
				size="lg"
				modal={isScheduledOpen}
				toggle={toggleScheduled}
				modalTitle="Scheduled Payments"
			>
				<ScheduledPayments autopayId={autoPayID} />
			</ChildrenModal>

			{/** New Payment Modal **/}
			<ChildrenModal
				size="lg"
				modal={showAdd}
				toggle={toggleAdd}
				// modalTitle="Setup Auto Pay"
			>
				<SetupAutoPay
					account={account}
					paymentMethods={paymentMethods}
					autoPays={autoPays}
					editAutoPays={editAutoPays}
					toggle={toggleAdd}
				/>
			</ChildrenModal>

			{/** Buttons & Drop-up **/}
			<Card>
				<CardBody>
					<Row>
						<Col sm="3" className="text-center">
							{account.status === 0 && (
								<Row className="justify-content-center align-items-center">
									<Dropdown
										direction="up"
										isOpen={isOpen}
										toggle={toggleMethod}
									>
										<DropdownToggle caret className="btn btn-primary btn-md">
											<i className="nc-icon nc-simple-add" /> Add Payment Method
										</DropdownToggle>
										<DropdownMenu end flip={false}>
											<DropdownItem onClick={handleCreditCard}>
												<i className="nc-icon nc-credit-card" /> Credit Card
											</DropdownItem>
											<DropdownItem onClick={handleACH}>
												<i className="nc-icon nc-bank" /> ACH
											</DropdownItem>
										</DropdownMenu>
									</Dropdown>

									<Button
										color="danger"
										size="md"
										className="ml-2"
										onClick={() => {
											setCurrentIndex(scheduledPayments.length);
											toggleAdd();
										}}
										disabled={!hasPermission}
									>
										<i className="nc-icon nc-simple-add" /> Setup Autopay
									</Button>
								</Row>
							)}
						</Col>

						<Col sm="6">
							<CardText tag="h3" className="text-center"></CardText>
						</Col>

						<Col sm="3">
							<CardText tag="h3" className="text-center">
								<Label>Regular Payment :{"\u00A0\u00A0"}</Label>
								<NumberFormat
									value={account.regularPayment}
									thousandSeparator
									decimalScale={2}
									fixedDecimalScale
									prefix="$"
									isNumericString
									displayType="text"
								/>
							</CardText>
						</Col>
					</Row>
				</CardBody>
			</Card>

			{/** Payment Methods Table **/}
			<Card className="mt-3">
				<CardBody>
					<CardText tag="h3">Payment Methods</CardText>
					<ReactTable data={paymentMethods} columns={pmColumns} />
				</CardBody>
			</Card>

			<Card className="mt-3">
				<CardBody>
					<CardText tag="h3">Auto Pay</CardText>
					<ReactTable data={autoPays} columns={autoPayColumns} />
				</CardBody>
			</Card>

			{/** Scheduled Payments Table **/}
			{/* <Card className="mt-3">
				<CardText tag="h3">Scheduled Payments</CardText>
				<CardBody>
					<ReactTable data={scheduledPayments} columns={shortColumns} />
				</CardBody>
			</Card> */}
			<Card className="mt-3">
				<CardText tag="h3"> Payments History</CardText>
				<CardBody>
					<ReactTable data={digitzsPayments} columns={pmtHistory} />
				</CardBody>
			</Card>
		</>
	);
};

export default AccountAutoPay;
